import { TJobInvitation } from '@microfrontends/react-components/components/ApplyJobs/types'
import {TBenefit, TIndustry, TWorkingLocation} from '@microfrontends/react-components/components/services/jobs/type'

export interface IClientSearchParams {
	query: string
	params: IQueryParameters
}

export interface IQueryParameters {
	query?: string
	filter?: object[]
	exclude?: object[]
	ranges?: object[]
	order?: object[]
	hitsPerPage?: number
	page?: number
	retrieveFields?: Array<string>
}
export enum EPageTab {
	UNSET = 'UNSET',
	JOBS = 'JOBS',
	MANAGEMENT_JOBS = 'MANAGEMENT_JOBS',
	INTERVIEW = 'INTERVIEW',
	SALARY = 'SALARY',
	ERROR404 = 'error404'
}

export type TSkills = {
	skillId: number
	skillName: string
	skillWeight: number
}
export interface IBenefit {
	benefitIconName: string
	benefitId: number
	benefitName: string
	benefitNameVI: string
	benefitValue: string
}
export interface Job {
	jobId: number;
	jobTitle: string;
	jobUrl: string;
	userId: number;
	companyLogo: string;
	alias: string;
	createdOn: string;
	approvedOn: string;
	expiredOn: string;
	lastUpdatedOn: string;
	lastSyncedOn: string;
	companyName: string;
	companyId: number;
	companyProfile: string;
	companySizeId: number;
	contactName: string;
	createdBy: number;
	isOnline: boolean;
	isActive: boolean;
	isApproved: boolean;
	isUnpaidDisable: number;
	isCompleted: boolean;
	isAnonymous: boolean;
	isSalaryVisible: boolean;
	isShowLogo: boolean;
	isShowLogoInSearch: boolean;
	jobDescription: string;
	jobRequirement: string;
	jobLevelId: number;
	languageId: number;
	languageSelectedId: number;
	languageSelectedVI: string;
	languageSelected: string;
	redirectTo: string;
	requiredCoverLetter: number;
	salary: string;
	salaryMax: number;
	salaryMin: number;
	typeWorkingId: number;
	skills: TSkills[];
	benefits: Partial<TBenefit[]>;
	workingLocations: Partial<TWorkingLocation[]>;
	address: string;
	industries: Partial<TIndustry[]>;
	industriesV3: any;
	jobLevel: string;
	jobLevelVI: string;
	jobLevelText?: string;
	locations: any;
	canonical: string;
	isShowContact: boolean;
	salaryRangeId: number;
	requiredResume: boolean;
	companySize: string;
	companySizeVI: string;
	simpleServices: any;
	services: any;
	prettySalary: string;
	durationDays: number;
	numOfApplications: number;
	emailAddress: string;
	isMobileHotJob: boolean;
	isMobileTopJob: boolean;
	isBoldAndRedJob: boolean;
	isUrgentJob: boolean;
	isUrgentJobM: boolean;
	onlineOn: string;
	visibilityDisplay: boolean;
	priorityOrder: string | number;
	nearestGeoLoc: any;
	profilePublishedSiteMask: number;
}
export interface IJobItem extends Job {
	logo?: string;
	title?: string;
	link?: string;
	locationsVI?: string;
	isTopLevelJob?: boolean; // this will be retrieved from another API
	isApplied?: boolean; // this will be retrieved from another API
	isSaved?: boolean; // this will be retrieved from another API
	isMatching?: boolean; // this will be retrieved from another API
	isBlackList?: boolean; // this will be retrieved from another API
	isViewed?: boolean // this will be retrieved from another API

	serviceCode?: string[],
	isPremium?: boolean,
	isTopManagementJob?: boolean,
	isHeadhuntJob?: boolean

	approvedDate?: number
	expiredDate?: number
	onlineDate?: number
}

export interface IFeaturedJobs {
	attributes?: {
		alias?: string | null
		cityNames?: string | null
		companyLogo?: string | null
		companyName?: string | null
		jobTitle?: string | null
		languageId?: string | null
		onlineTopJobDate?: string | null
		typeTopJob?: string | null
		url?: string | null
	} | null
	id?: number | null
	type?: 'featuredJobs'
}

export interface ResponseJobSearch {
	hits: []
	hitsPerPage: number
	nbHits: number
	nbPage: number
	page: number
	params: string
	query: string
}
export interface ISpecialJobs {
	type: string
	id: number
	attributes: {
		saved: boolean
		applied: boolean
		matching: boolean
		redirectTo: string
		userBlackList: boolean
		viewed: boolean
		jobInvitation: TJobInvitation
	}
}

interface Filter {
	field?: string
	value?: string
}

interface Order {
	field?: string
	value?: string
}

interface Range {
	field: string
	value: string
	operator: string | null
}

export type TJobItem = {
	title?: string | null
	company?: string | null
	locations?: string[]
	logo?: string | null
	url?: string | null
	isAnonymous: boolean
}

export type TCountJob = {
	key: number
	doc_count: number
}

export enum EMetaJobs {
	industries = 'industries',
	levels = 'levels',
	typeWorkings = 'typeWorkings',
	cities = 'cities'
}

export const initParams = {
	query: '',
	filter: [{ field: '', value: '' }],
	ranges: [],
	order: [],
	hitsPerPage: 50,
	page: 0,
	retrieveFields: [
		'benefits',
		'jobTitle',
		'salaryMax',
		'isSalaryVisible',
		'jobLevelVI',
		'isShowLogo',
		'salaryMin',
		'companyLogo',
		'userId',
		'jobLevel',
		'jobLevelId',
		'jobId',
		'companyId',
		'approvedOn',
		'isAnonymous',
		'alias',
		'expiredOn',
		'industries',
		'workingLocations',
		'services',
		'companyName',
		'salary',
		'prettySalary',
		'onlineOn',
		'simpleServices',
		'visibilityDisplay',
		'isShowLogoInSearch',
		'priorityOrder',
		'skills'
	]
}

export const defaultLogo =
	'https://images.vietnamworks.com/img/company-default-logo.svg'
